import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { amber } from '@mui/material/colors';
import {styled} from '@mui/system';

import ActionButton from '../component/atoms/ActionButton';


const StyledWarningMode = styled(DialogTitle)({
    backgroundColor: amber[700]
});

const StyledDialogActions = styled(DialogActions)({
    marginBottom: 5
})

const StyledTextBlock = styled('span')({
    display: 'block'
})

const StyledConfirmation = styled(StyledTextBlock)({
    border: '1px solid',
    borderColor: amber[700],
    padding: 10,
    marginTop: 10
})


class CustomConfirmationDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            confirmationButtonActive: true
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);

    }

    componentDidUpdate(previewProps){
        if (previewProps.data.plausibility_warnings !== this.props.data.plausibility_warnings && this.props.data.plausibility_warnings) {
            this.setState({confirmationButtonActive: false});
        }
    }

    handleClose(event) {
        this.props.data.on_close(event);
    }

    handleConfirm(event) {
        this.props.data.on_confirm(event);
    }

    handleConfirmationChange = (event) => {
        this.setState({confirmationButtonActive: event.target.checked});
    };


    additionalConfirmation = () => {
        if (this.props.data.plausibility_warnings) {
            return (
                <StyledConfirmation>
                    {this.props.data.plausibility_warnings.map((plausibility_warning, index) =>
                        <span key={index}>{plausibility_warning}<br/></span>
                    )}
                    Are you sure?
                    <Checkbox
                        checked={this.state.confirmationButtonActive}
                        onChange={this.handleConfirmationChange}
                        value="primary"
                        slotProps={{ htmlInput: { 'aria-label': 'primary checkbox' } }}
                    />
                </StyledConfirmation>
            );
        }
        return <span></span>;
    };


    render() {
        if (this.props.data.is_open) {
            let StyledDialogTitle = this.props.data.confirmation === undefined ? DialogTitle : StyledWarningMode;
            return (
                <Dialog
                    open={this.props.data.is_open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <StyledDialogTitle id="responsive-dialog-title">Please confirm!</StyledDialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <StyledTextBlock>Are you sure to perform the following actions on this workspace?</StyledTextBlock>
                            {this.props.data.statistics.inserts} inserts<br/>
                            {this.props.data.statistics.updates} updates<br/>
                            {this.props.data.statistics.deletes} deletes<br/>
                            {this.props.data.statistics.unmodified} not modified
                            {this.additionalConfirmation()}
                        </DialogContentText>
                    </DialogContent>
                    <StyledDialogActions>
                        <span>
                            <ActionButton text="Cancel" actionCallback={this.handleClose}
                                          linkStyle={true} hotKey="alt+x"/>
                            <ActionButton text="Ok" dataBt="confirm_button"
                                          disabled={!this.state.confirmationButtonActive}
                                          actionCallback={this.handleConfirm} linkStyle={true}
                                          hotKey="alt+o"/>
                        </span>
                    </StyledDialogActions>
                </Dialog>
            );
        }
        return <span></span>;
    }
}


CustomConfirmationDialog.propTypes = {
    data: PropTypes.object.isRequired
};

export default CustomConfirmationDialog;
